//dependencies
import collapse from "angular-ui-bootstrap/src/collapse";
import dropdown from "angular-ui-bootstrap/src/dropdown";
import tabs from "angular-ui-bootstrap/src/tabs";

//services

//components
import shipLocationContainer from "emun.cust/locations/ship-location-container";

//directives
// import custList from "emun.cust/locations/ship-location-list";

//states
import getStates from "emun.cust/locations/ship-location.states";

//styles
// import "emun.cust/locations/ship-location.styles";

export const dependencies = [dropdown, collapse, tabs];

export const modules = {
  // modals,
};

export const services = {};

export const components = {
  shipLocationContainer,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states: getStates(),
};
